import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=31604ed2&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=31604ed2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31604ed2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31604ed2')) {
      api.createRecord('31604ed2', component.options)
    } else {
      api.reload('31604ed2', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=31604ed2&scoped=true", function () {
      api.rerender('31604ed2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/attendance_details/components/edit.vue"
export default component.exports